import { render, staticRenderFns } from "./FormMotorDataTable.vue?vue&type=template&id=076a9cd3&scoped=true"
import script from "./FormMotorDataTable.vue?vue&type=script&lang=ts"
export * from "./FormMotorDataTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076a9cd3",
  null
  
)

export default component.exports